import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7752affa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-40" }
const _hoisted_2 = { class: "products" }
const _hoisted_3 = { class: "product min-h-250" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "flex flex-nowrap items-center" }
const _hoisted_6 = { class: "c-magic-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductLineItem = _resolveComponent("ProductLineItem")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$dictionary.get('b2b/basket/myBasketSubtotal')) + " " + _toDisplayString(_ctx.basket.total.amountWithDecimals), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
        return (_openBlock(), _createBlock(_component_ProductLineItem, {
          key: product.id,
          product: product,
          class: "product"
        }, null, 8, ["product"]))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: "/en/basket/",
          title: _ctx.$dictionary.get('b2b/basket/goToBasket'),
          class: "bg-wild-sand flex h-full flex-col justify-center items-center"
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$dictionary.get('b2b/basket/goToBasket')), 1),
            _createVNode(_component_c_icon, {
              name: "icon-arrow-small",
              class: "h-8 mt-2 xl:mt-0"
            })
          ])
        ], 8, _hoisted_4)
      ])
    ])
  ]))
}